import {isPlanCurrencyQuestion} from './planCurrency';
import {isPlanBasisQuestion} from './planBasis';
import {isGroupMappingQuestion} from './groupMapping';

// El contrato guardado identifica el destino de una respuesta por sus pins. Centralizar esa
// compatibilidad evita tratar cualquier decisión con opciones como una campaña sin identificar.
// `blocking` significa que el endpoint rechaza responder: se conserva como aviso, tenga opciones o no.
// Las dudas de la base de los montos y del reparto de grupos van antes que eso: se responden en sus
// bloques propios (`plan_basis`, `group_mapping`), así que no son ni aviso ni decisión de la lista.
export function proposalQuestionKind(item) {
    const question = (item && item.question) || {};
    if (isPlanBasisQuestion(item)) return 'basis';
    if (isGroupMappingQuestion(item)) return 'group_mapping';
    if (question.blocking) return 'notice';
    if (isPlanCurrencyQuestion(item)) return 'currency';
    const pin = typeof question.profile_pin_key === 'string' ? question.profile_pin_key : '';
    // Un `budget_for::` sin opciones pide el monto; CON opciones (el resto de un plan parcial: «¿a qué
    // línea va la diferencia, o no se sigue?») se responde eligiendo una, y el endpoint rechaza un monto.
    if (pin.startsWith('budget_for::')) return (question.options || []).length ? 'generic' : 'budget';
    if (!(question.options || []).length) return 'notice';
    if (question.alias_pin_key) return 'campaign';
    if (pin === 'range_period_choice' || pin === 'date_ambiguity_choice') return 'period';
    if (pin.startsWith('account_for::')) return 'account';
    // No se inventan pins, opciones ni respuestas para contratos desconocidos.
    return 'generic';
}

// La opción `untracked` («No seguir…») llega con el texto del backend en español: se muestra con el copy
// del idioma de la pantalla según de qué es la duda (una cuenta o el resto del plan). La clave no cambia.
// Devuelve la clave i18n o null.
export function untrackedOptionLabelKey(item, option) {
    if (!option || option.key !== 'untracked') return null;
    const pin = ((item && item.question) || {}).profile_pin_key;
    if (typeof pin !== 'string') return null;
    if (pin.startsWith('account_for::')) return 'media_plan.untracked.account_option_untracked';
    if (pin.startsWith('budget_for::')) return 'media_plan.group_mapping.option_untracked';
    return null;
}

export function partitionProposalQuestions(items) {
    const groups = {currency: [], period: [], account: [], campaign: [], budget: [], generic: [], notice: [],
                    basis: [], group_mapping: []};
    for (const item of items || []) {
        if (item.action_type !== 'NEEDS_DECISION' || item.review_status !== 'PENDING_REVIEW') continue;
        groups[proposalQuestionKind(item)].push(item);
    }
    return groups;
}
